import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const BarChartSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default BarChartSVG;
